enum IdentificationFormPath {
  IdentificationFormFillData = "/identification-form/:tripId/fill-data",
  IdentificationFormCheckData = "/identification-form/:tripId/check-data",
  IdentificationFormConfirmation = "/identification-form/:tripId/confirmation",
}

export enum IdentificationFormStep {
  FillData = "fill-data",
  CheckData = "check-data",
  Confirmation = "confirmation",
}

export default IdentificationFormPath;
